export enum ExportMessageSeverity {
  Warning = 'Warning',
  Error = 'Error',
}

export interface ExportMessage {
  message: string;
  type: ExportMessageSeverity;
}
